import React from 'react';
import classNames from 'classnames';
import TagModel from '@mm/state/model/TagModel';
import PrimarySelect from '@mm/components/legacy-components/PrimarySelect/PrimarySelect';
import { ConnectionTagModel } from '@mm/state/model/ConnectionTagModel';
import { createConnectionTag } from '@mm/state/helpers/connection-helpers';

type Props = {
  index: number;
  tag: ConnectionTagModel;
  options: TagModel[];
  onChange: (v: ConnectionTagModel, i: number) => void;
  className?: string;
};

export const ConnectionTagSelect = ({
  className,
  tag,
  options,
  onChange,
  index,
}: Props) => {
  const tagsWithIds = options
    .map(({ name }) => createConnectionTag(name))
    .map(({ name }) => ({ id: name, name }));
  const value = tag.name ? { id: tag.name, ...tag } : undefined;
  return (
    <PrimarySelect
      className={classNames(className)}
      value={value}
      placeholder="Select Tag"
      options={tagsWithIds}
      onChange={({ id }) => onChange(createConnectionTag(String(id)), index)}
    />
  );
};
